(() => {
  const init = () => {
    const stickyBar = document.querySelector('.shopify-section--main-product .product-sticky-bar');
    const mainButton = document.querySelector('.shopify-section--main-product .product-info__block-item[data-block-type="buy-buttons"] .buy-buttons > .button');
    const footer = document.querySelector('.shopify-section--footer');

    if (!stickyBar || !mainButton) return;

    let mainButtonVisible = false;
    let footerVisible = false;
    let ticking = false;

    const update = () => {
      ticking = false;

      if (window.matchMedia('(min-width: 700px)').matches) {
        stickyBar.removeAttribute('data-driplocker-visible');
        return;
      }

      const revealAfter = Math.max(260, window.innerHeight * 0.55);
      const shouldShow = window.scrollY > revealAfter && !mainButtonVisible && !footerVisible;
      stickyBar.setAttribute('data-driplocker-visible', shouldShow ? 'true' : 'false');
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    const buttonObserver = new IntersectionObserver((entries) => {
      mainButtonVisible = entries[0]?.isIntersecting ?? false;
      requestUpdate();
    }, { threshold: 0.12 });

    buttonObserver.observe(mainButton);

    if (footer) {
      const footerObserver = new IntersectionObserver((entries) => {
        footerVisible = entries[0]?.isIntersecting ?? false;
        requestUpdate();
      }, { threshold: 0.01 });
      footerObserver.observe(footer);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
